var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import classNames from 'classnames';
import React from 'react';
import s from './styles.module.css.json';
/**
 * @example Inline spinner
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   Foo bar <Spinner size={24} />
 * </Canvas>;
 * ```
 *
 * @example Centered spinner
 *
 * ```js
 * <Canvas ctx={ctx}>
 *   <div style={{ height: '200px', position: 'relative' }}>
 *     <Spinner size={48} placement="centered" />
 *   </div>
 * </Canvas>;
 * ```
 */
export function Spinner(_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 32 : _c, _d = _a.placement, placement = _d === void 0 ? 'inline' : _d, _e = _a.style, extraStyle = _e === void 0 ? {} : _e;
    var bars = [];
    for (var i = 0; i < 12; i += 1) {
        var barStyle = {};
        barStyle.animationDelay = (i - 12) / 10 + "s";
        barStyle.transform = "rotate(" + i * 30 + "deg) translate(146%)";
        bars.push(React.createElement("div", { style: barStyle, className: s['Spinner__bar'], key: i }));
    }
    var style = {
        width: size * 0.5,
        height: size * 0.5,
    };
    if (placement === 'inline') {
        style.marginLeft = size * 0.5;
        style.transform = 'translateY(33%)';
    }
    return (React.createElement("div", { className: classNames((_b = {},
            _b[s['Spinner--inline']] = placement === 'inline',
            _b[s['Spinner--centered']] = placement === 'centered',
            _b)), style: __assign(__assign({}, extraStyle), style) }, bars));
}
//# sourceMappingURL=index.js.map